import React from 'react';
import { object, func, bool } from 'prop-types';
import TitlePrice from '../TitlePrice/TitlePrice';
import EditDishRadioButtonGroup from './EditDishRadioButtonGroup';
import RadioButton from '../RadioButton/RadioButton';
import Variation from './Variation';
import styles from './EditDishRadioButtonGroup.scss';
import classNames from 'classnames';

export default function VariationRadio({ part, onChange, displayErrorIndication, errorIndicationOverrides, disabled }) {
  return (
    <EditDishRadioButtonGroup
      value={part.value}
      onChange={choiceId => onChange(part.variationPath, choiceId, part.clientSideId)}
      disabled={disabled}
    >
      {part.choices.map(choice => {
        const hasSubVariations = choice.subVariations.length > 0;
        return (
          <React.Fragment key={choice.clientSideId}>
            <RadioButton
              name={part.clientSideId}
              value={choice.itemId}
              className={classNames({ [styles.hasSubVariations]: hasSubVariations })}
              dataHook="variationChoice"
              disabled={disabled}
            >
              <TitlePrice title={choice.title} price={choice.price} />
            </RadioButton>
            {choice.subVariations.map((subVariation, index) => (
              <Variation
                key={subVariation.clientSideId}
                part={subVariation}
                onChange={onChange}
                displayErrorIndication={displayErrorIndication}
                errorIndicationOverrides={errorIndicationOverrides}
                indent
                showArrow={index === 0}
              />
            ))}
          </React.Fragment>
        );
      })}
    </EditDishRadioButtonGroup>
  );
}

VariationRadio.propTypes = {
  part: object,
  onChange: func,
  displayErrorIndication: bool,
  errorIndicationOverrides: object,
  disabled: bool,
};
